import React from 'react';

function Error() {
  return (
    <div className="col-xs-12 col-lg-10 col-xl-8 offset-xl-2 offset-lg-1 no-padding-left return-error-padding">
      <h1 className="heading6">{_THULEDATA._Returns.LoginToCreateReturn}</h1>
      <a href={_THULEDATA._Returns.LoginUrl}>{_THULEDATA._Returns.Login}</a>
    </div>
  );
}

export default Error;
